import { luscinia } from "../luscinia";
import type { Bootgrid } from "./bootgrid";

export function constructCss(this: Bootgrid) {
    return {
        search: "search form-group pull-left",
        selected: luscinia.css.rowHighlight,
        selectCell: "select-cell" + (this.bootgridSettings.showCheckBox ? "" : " hidden"),
        infos: "infos" + (this.bootgridSettings.showFooterInfoBar ? "" : " hidden"),
        iconColumnSearchToggleCollapsed: "fa fa-search-plus",
        iconColumnSearchToggleUncollapsed: "fa fa-search-minus",
    };
}

export function constructTemplates(this: Bootgrid) {
    return {
        header: this.bootgridSettings.showActionHeader
            ? `<div id='{{ctx.id}}' class='{{css.header}}'>
                    <div class='actionBar-left d-flex gap-1'>
                        ${this.bootgridSettings.buttonHeaderNew}
                        ${this.bootgridSettings.buttonHeaderEdit}
                        ${this.bootgridSettings.buttonHeaderDelete} 
                        ${this.bootgridSettings.buttonHeaderExport}
                    </div>
                    <div class="actionBar-right d-flex gap-1"> 
                        <p class='{{css.search}}'></p>
                        <p class='{{css.actions}}'></p>
                    </div>
                </div>`
            : "",
        actionDropDownCheckboxItem:
            `<li>
                <label class="{{css.dropDownItem}}">
                    <input type="checkbox" value="1" class="{{css.dropDownItemCheckbox}}" {{ctx.checked}} />
                    {{ctx.label}}
                </label>
            </li>`,
        search: this.bootgridSettings.showSearchInput
            ? `<div class="{{css.search}}">
                    <div class="input-group">
                        <span class="input-group-text">
                            <i class="{{css.iconSearch}}"></i>
                        </span>
                        <input type="text" class="{{css.searchField}}" placeholder="{{lbl.search}}" />
                    </div>
               </div>`
            : "",
        columnSearchToggle:
        `<button type="button" class="{{css.columnSearchToggle}}">
            <i class="{{css.iconColumnSearchToggle}}"></i>
         </button>`,
    };
}

export function constructLabels(this: Bootgrid) {
    return {
        all: this.config.translations.bootgridAll,
        infos: this.config.translations.bootgridInfos,
        loading: this.config.translations.bootgridLoading,
        noResults: this.config.translations.bootgridNoResults,
        refresh: this.config.translations.bootgridRefresh,
        search: this.config.translations.bootgridSearch,
    };
}
